import '@babel/polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { configureStore } from './store'
import './assets/stylesheets/sass/bootstrap.scss'
import './assets/stylesheets/sass/fontawesome.scss'
import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-phone-number-input/style.css'
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import './assets/stylesheets/sass/app.scss'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next';
import {i18next} from 'App/translations'
import {RootContainer} from "Containers/RootContainer";
import registerServiceWorker from './registerServiceWorker';
import TagManager from 'react-gtm-module';

// Init GTM
TagManager.initialize({
    gtmId: 'GTM-W8DVQGF'
});

// Init redux store
const store = configureStore();

// Go
ReactDOM.render(
    <I18nextProvider i18n={i18next}>
        <Provider store={store}>
            <RootContainer />
        </Provider>
    </I18nextProvider>,
    document.getElementById('root') as HTMLElement
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx